import React from 'react'
import HouseCard from './HouseCard'

class HouseView extends React.Component{
    
    render (){
        return (
            <div>
                {this.props.houses.map(house => {
                    return (
                        <div key={house._id}>
                            <HouseCard  house={house} getHouseDetails={this.props.getHouseDetails} ></HouseCard>
                        </div>
                    )
                })}
            </div>
        )
    }
}

export default HouseView